import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { NOTIFICATIONS } from '@framework/constants/dataTestId';

import {
    dismissSnackbar,
    getSnackbars,
    type Snackbar as SnackbarType
} from '@redux/reducers/snackbars.duck';

import { Portal, Snackbar } from 'styled-system';

import styles from './Snackbars.module.scss';

const Snackbars = () => {
    const dispatch = useDispatch();
    const snackbars = useSelector(getSnackbars);

    const renderedSnackbars = snackbars.map((snackbar: SnackbarType) => (
        <Snackbar
            button={snackbar.button}
            dismissAfter={snackbar.dismissAfter}
            dismissAllowed={snackbar.dismissAllowed}
            hideCloseButton={snackbar.hideCloseButton}
            header={snackbar.header}
            loading={snackbar.loading}
            id={snackbar.id}
            key={snackbar.id}
            message={snackbar.message}
            onDismiss={() => {
                snackbar.onDismiss?.();
                dispatch(dismissSnackbar(String(snackbar.id)));
            }}
            type={snackbar.type}
            width={snackbar.width}
        />
    ));

    return (
        <Portal selector="body">
            <div className={styles.notifications} data-testid={NOTIFICATIONS}>
                {renderedSnackbars}
            </div>
        </Portal>
    );
};

export default Snackbars;
